import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';


const getDirectFilesCount = (directId) => {
  return axios.get(
    `/api/directs/${directId}/files/count`
  );
};

export const useDirectFilesCount = (directID, options = {}) => {
  return useQuery(
    `direct-${directID}-files-count`,
    () => getDirectFilesCount(directID),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
};